/**
 * Get selected (checked) input elements matching the given selectors.
 *
 * @param {string} rootSelector
 * @param {string} inputSelector
 * @returns {[]}
 */
export function getSelected(rootSelector, inputSelector) {
    const entities = []
    const regex = new RegExp(`${inputSelector}\\[(\\d+)]`)

    $(`${rootSelector} input[name^="${inputSelector}"]`).each(function() {
        const $checkbox = $(this)

        if ($checkbox.prop('checked')) {
            const id = regex.exec($checkbox.attr('name'))

            if (id !== null) {
                entities.push(id[1])
            }
        }
    })

    return entities
}
